import { Injectable } from "@angular/core";
import { appCommonConstants } from "../../../app.constants";
import { AppEventService } from "../../../services/event.service";
import { AppSignalRService } from "../../../services/signalR.service";

@Injectable({
  providedIn: 'root',
})

export class AppCrmInitService {
  constructor(
    private eventService: AppEventService,
    private signalrService: AppSignalRService) { }

  private isInited = false;

  /** Inizializzazione */
  public init(): void {
    if (this.isInited) {
      return;
    }
    this.isInited = true;

    // All'init di SignalR, registra il client sull'evento di default entityCrudNotification
    this.eventService.on(appCommonConstants.events.signalR.initialized).subscribe(() => {
      this.signalrService.listenerSetUp({ name: appCommonConstants.events.signalR.listeners.entityCrudNotification, filter: false, broadcastEvent: appCommonConstants.events.signalR.listeners.entityCrudNotification }, true, true);
    });
  }
}
